import { useEffect, useState } from "react";

export default function useDebouncedValue(value, delayMs = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delayMs);

    return () => {
      clearTimeout(timer);
    };
  }, [delayMs, value]);

  return debouncedValue;
}

export function useDebouncedState(initialValue, delayMs = 500) {
  const [value, setValue] = useState(initialValue);
  const debouncedValue = useDebouncedValue(value, delayMs);

  return [debouncedValue, setValue];
}
